__turbopack_context__.v({
  "className": "cormorant_garamond_c96b2fb1-module__wJgMVG__className",
});
